// extracted by mini-css-extract-plugin
export default {"wrap":"AdminMain_wrap__n8d57"};